module.exports = __webpack_public_path__ + "img/buentrabajo_720x1280.f0fbdfa2.png";